import React from 'react';
import { CognitoAuthSession, CognitoAuth, CognitoAuthOptions } from 'amazon-cognito-auth-js';

export const REDIRECT_URI =
  process.env.NODE_ENV === 'production'
    ? 'https://snapshotvr.com/oldaccount'
    : 'http://localhost:3000/oldaccount';

const {
  REACT_APP_COGNITO_CLIENT_ID = '',
  REACT_APP_COGNITO_IDENTITY_POOL_ID = '',
} = process.env;

const authData: CognitoAuthOptions = {
  ClientId: REACT_APP_COGNITO_CLIENT_ID,
  AppWebDomain: 'account.snapshotvr.com',
  TokenScopesArray: [
    'aws.cognito.signin.user.admin',
    'email',
    'openid',
    'phone',
    'profile',
  ],
  RedirectUriSignIn: REDIRECT_URI,
  RedirectUriSignOut: REDIRECT_URI,
  UserPoolId: REACT_APP_COGNITO_IDENTITY_POOL_ID,
};

export const cognitoAuth = new CognitoAuth(authData);

type CognitoAuthContextType = {
  session?: CognitoAuthSession;
  instance: CognitoAuth;
};

const CognitoAuthContext = React.createContext<CognitoAuthContextType>({ instance: cognitoAuth });

export const CognitoAuthProvider: React.FC = props => {
  const [session, setSession] = React.useState<
    CognitoAuthSession | undefined
  >();
  cognitoAuth.userhandler = {
    onSuccess(session) {
      setSession(session);
    },
    onFailure(err) {
      console.warn(err);
      setSession(undefined);
    },
  };

  return (
    <CognitoAuthContext.Provider value={{ session, instance: cognitoAuth }}>
      {props.children}
    </CognitoAuthContext.Provider>
  );
};

export const useCognitoAuthContext = () => React.useContext(CognitoAuthContext);
